/**
 * THE SOMMELIER — Vanilla JS Widget for The Liquid Collection
 * =====================================================================
 * Drop this file into Shopify as `assets/sommelier.js`, then add ONE line
 * to theme.liquid (just before </body>):
 *   <script src="{{ 'sommelier.js' | asset_url }}" defer></script>
 *
 * Configure WORKER_URL below to point at your deployed Cloudflare Worker.
 * =====================================================================
 */
(function () {
  "use strict";

  // ====== CONFIG — edit this after deploying your Worker ======
  const WORKER_URL = "https://sommelier.rothesay5999.workers.dev";
  // ============================================================

  // Don't load on cart / checkout pages
  if (/\/(cart|checkout)/.test(window.location.pathname)) return;

  // Prevent double-init
  if (window.__tlcSommelierLoaded) return;
  window.__tlcSommelierLoaded = true;

  // ---------- state ----------
  const state = {
    isOpen: false,
    messages: [],
    loading: false,
    catalog: [],
    catalogStatus: "loading", // loading | live | empty
  };

  // ---------- styles ----------
  const STYLES = `
    .tlc-som-bubble-wrap {
      position: fixed; bottom: 24px; right: 24px; z-index: 99998;
      display: flex; align-items: center; gap: 12px;
    }
    .tlc-som-label {
      background: #1A1410; color: #F4ECDC;
      padding: 10px 16px; border-radius: 24px;
      font-family: 'Cormorant Garamond', Georgia, serif;
      font-size: 14px; font-style: italic; letter-spacing: 0.02em;
      border: 1px solid rgba(201, 160, 99, 0.3);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
      white-space: nowrap; cursor: pointer;
      display: flex; align-items: center; gap: 10px;
      animation: tlc-som-label-in 0.6s ease-out 1s both;
      transition: opacity 0.2s ease, transform 0.2s ease;
    }
    .tlc-som-label:hover { transform: translateX(-2px); border-color: #C9A063; }
    .tlc-som-label-close {
      width: 18px; height: 18px; border-radius: 50%;
      background: rgba(201, 160, 99, 0.15); color: #9C8F7A;
      display: flex; align-items: center; justify-content: center;
      font-size: 14px; font-family: system-ui, sans-serif; font-style: normal;
      line-height: 1; transition: background 0.2s ease;
    }
    .tlc-som-label-close:hover { background: rgba(201, 160, 99, 0.3); color: #F4ECDC; }
    @keyframes tlc-som-label-in {
      0% { opacity: 0; transform: translateX(20px); }
      100% { opacity: 1; transform: translateX(0); }
    }
    .tlc-som-bubble {
      width: 64px; height: 64px;
      border-radius: 50%; border: none; cursor: pointer;
      background: radial-gradient(circle at 30% 30%, #E8C68C 0%, #C9A063 40%, #8B6332 100%);
      box-shadow: 0 8px 32px rgba(201, 160, 99, 0.4), 0 0 0 1px rgba(232, 198, 140, 0.3) inset;
      display: flex; align-items: center; justify-content: center;
      transition: transform 0.2s ease;
      padding: 0;
    }
    .tlc-som-bubble:hover { transform: scale(1.05); }
    .tlc-som-bubble svg { width: 32px; height: 32px; color: #1a0e05; }
    .tlc-som-bubble-pulse {
      position: absolute; top: -2px; right: -2px; width: 12px; height: 12px;
      border-radius: 50%; background: #E8C68C;
      animation: tlc-som-pulse 2s infinite;
    }
    @keyframes tlc-som-pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.5; transform: scale(1.3); }
    }

    .tlc-som-panel {
      position: fixed; z-index: 99999; display: flex; flex-direction: column;
      background: #0E0B08; overflow: hidden;
      border: 1px solid rgba(201, 160, 99, 0.2);
      box-shadow: 0 20px 60px rgba(0,0,0,0.5);
      font-family: 'Albert Sans', system-ui, -apple-system, sans-serif;
      color: #F4ECDC;
    }
    @media (min-width: 768px) {
      .tlc-som-panel {
        bottom: 24px; right: 24px; width: 400px; height: 640px;
        border-radius: 16px;
      }
    }
    @media (max-width: 767px) {
      .tlc-som-panel { inset: 0; }
    }

    .tlc-som-header {
      padding: 16px 20px; display: flex; align-items: center; justify-content: space-between;
      border-bottom: 1px solid rgba(201, 160, 99, 0.15); flex-shrink: 0;
    }
    .tlc-som-title {
      font-family: 'Cormorant Garamond', Georgia, serif;
      font-size: 18px; font-weight: 500; letter-spacing: 0.02em; line-height: 1.2;
    }
    .tlc-som-subtitle {
      font-size: 10px; text-transform: uppercase; letter-spacing: 0.2em;
      color: #9C8F7A; margin-top: 2px;
    }
    .tlc-som-close {
      background: transparent; border: none; cursor: pointer; color: #9C8F7A;
      width: 32px; height: 32px; border-radius: 50%; font-size: 20px; line-height: 1;
      display: flex; align-items: center; justify-content: center;
      transition: background 0.2s ease;
    }
    .tlc-som-close:hover { background: #1A1410; }

    .tlc-som-body {
      flex: 1; overflow-y: auto; padding: 16px 20px; display: flex; flex-direction: column; gap: 20px;
      scrollbar-width: thin; scrollbar-color: #2A211A transparent;
    }
    .tlc-som-body::-webkit-scrollbar { width: 6px; }
    .tlc-som-body::-webkit-scrollbar-thumb { background: #2A211A; border-radius: 3px; }

    .tlc-som-welcome {
      text-align: center; padding-top: 32px;
    }
    .tlc-som-welcome-title {
      font-family: 'Cormorant Garamond', Georgia, serif;
      font-size: 28px; font-style: italic; color: #C9A063; margin-bottom: 12px;
    }
    .tlc-som-welcome-body {
      font-size: 13px; color: #9C8F7A; line-height: 1.6; padding: 0 16px;
    }

    .tlc-som-msg-user {
      align-self: flex-end; max-width: 85%;
      padding: 10px 16px; border-radius: 18px 18px 4px 18px;
      background: #2A211A; color: #F4ECDC;
      font-size: 14px; line-height: 1.5; word-wrap: break-word;
    }
    .tlc-som-msg-asst { display: flex; flex-direction: column; gap: 12px; }
    .tlc-som-msg-asst-label {
      font-size: 11px; text-transform: uppercase; letter-spacing: 0.2em; color: #C9A063;
      font-family: 'Cormorant Garamond', Georgia, serif; font-style: italic;
    }
    .tlc-som-msg-asst-text {
      font-size: 14px; line-height: 1.6; color: #F4ECDC; white-space: pre-wrap;
    }

    .tlc-som-product {
      display: flex; align-items: center; gap: 12px; padding: 12px;
      border-radius: 8px; background: #1A1410; border: 1px solid #2A211A;
      text-decoration: none; color: inherit; transition: border-color 0.2s ease;
    }
    .tlc-som-product:hover { border-color: #C9A063; }
    .tlc-som-product-img {
      width: 56px; height: 56px; flex-shrink: 0; border-radius: 6px;
      background: #0E0B08; overflow: hidden;
      display: flex; align-items: center; justify-content: center;
    }
    .tlc-som-product-img img {
      width: 100%; height: 100%; object-fit: contain;
    }
    .tlc-som-product-img-fallback {
      color: #C9A063; font-family: 'Cormorant Garamond', Georgia, serif;
      font-size: 22px; font-style: italic;
    }
    .tlc-som-product-info { flex: 1; min-width: 0; }
    .tlc-som-product-title {
      font-size: 13px; line-height: 1.3; color: #F4ECDC; font-weight: 500;
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .tlc-som-product-type {
      font-size: 11px; color: #9C8F7A; margin-top: 2px;
    }
    .tlc-som-product-price {
      font-size: 13px; font-weight: 600; color: #E8C68C;
      white-space: nowrap; flex-shrink: 0;
    }

    .tlc-som-loading {
      display: flex; align-items: center; gap: 8px; color: #9C8F7A; font-size: 13px;
      font-family: 'Cormorant Garamond', Georgia, serif; font-style: italic;
    }
    .tlc-som-spinner {
      width: 14px; height: 14px; border: 2px solid #2A211A; border-top-color: #C9A063;
      border-radius: 50%; animation: tlc-som-spin 0.8s linear infinite;
    }
    @keyframes tlc-som-spin { to { transform: rotate(360deg); } }

    .tlc-som-starters {
      display: grid; grid-template-columns: 1fr 1fr; gap: 8px; padding: 0 16px 12px;
      flex-shrink: 0;
    }
    .tlc-som-starter {
      display: flex; align-items: center; gap: 8px; padding: 10px 12px;
      border-radius: 8px; background: #1A1410; border: 1px solid #2A211A;
      cursor: pointer; text-align: left; color: #F4ECDC; font-size: 12px;
      font-family: inherit; transition: all 0.2s ease; line-height: 1.2;
    }
    .tlc-som-starter:hover { border-color: #C9A063; background: #221B14; }
    .tlc-som-starter-icon { font-size: 14px; flex-shrink: 0; }

    .tlc-som-input-area {
      padding: 12px 16px; border-top: 1px solid rgba(201, 160, 99, 0.15);
      flex-shrink: 0;
    }
    .tlc-som-input-row {
      display: flex; align-items: flex-end; gap: 8px;
      background: #1A1410; border: 1px solid #2A211A; border-radius: 12px;
      padding: 8px 12px; transition: border-color 0.2s ease;
    }
    .tlc-som-input-row:focus-within { border-color: #C9A063; }
    .tlc-som-input {
      flex: 1; background: transparent; border: none; outline: none; resize: none;
      color: #F4ECDC; font-size: 14px; line-height: 1.5; max-height: 120px;
      font-family: inherit;
    }
    .tlc-som-input::placeholder { color: #6B6055; }
    .tlc-som-send {
      width: 36px; height: 36px; border-radius: 50%; border: none; cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      background: #2A211A; color: #6B6055;
      transition: all 0.2s ease; flex-shrink: 0;
      font-size: 14px;
    }
    .tlc-som-send.tlc-som-send-active {
      background: radial-gradient(circle at 30% 30%, #E8C68C 0%, #C9A063 100%);
      color: #1a0e05;
    }
    .tlc-som-send.tlc-som-send-active:hover { transform: scale(1.05); }
    .tlc-som-send:disabled { cursor: not-allowed; }

    .tlc-som-footer-note {
      font-size: 10px; color: #6B6055; text-align: center; margin-top: 8px;
      letter-spacing: 0.05em;
    }
  `;

  function injectStyles() {
    // Google Fonts
    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Albert+Sans:wght@400;500;600&display=swap";
    document.head.appendChild(fontLink);

    // Component styles
    const style = document.createElement("style");
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  // ---------- helpers ----------
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function extractRecs(text) {
    const m = text.match(/\[REC\]([^\[]+)\[\/REC\]/);
    if (!m) return { text: text.trim(), handles: [] };
    const handles = m[1].split(",").map((h) => h.trim()).filter(Boolean);
    return { text: text.replace(/\[REC\][^\[]+\[\/REC\]/, "").trim(), handles };
  }

  function findProduct(handle) {
    return state.catalog.find((p) => p.handle === handle);
  }

  function formatPrice(price) {
    return Number.isInteger(price) ? `S$${price}` : `S$${price.toFixed(2)}`;
  }

  // ---------- catalog fetch ----------
  async function fetchCatalog() {
    try {
      const all = [];
      for (let page = 1; page <= 5; page++) {
        const res = await fetch(`/products.json?limit=250&page=${page}`);
        if (!res.ok) break;
        const data = await res.json();
        if (!data.products || data.products.length === 0) break;
        all.push(
          ...data.products.map((p) => ({
            handle: p.handle,
            title: p.title,
            type: p.product_type || "Spirit",
            price: parseFloat(p.variants?.[0]?.price || "0"),
            image: p.images?.[0]?.src || null,
          }))
        );
        if (data.products.length < 250) break;
      }
      state.catalog = all.filter((p) => p.price > 0);
      state.catalogStatus = state.catalog.length > 0 ? "live" : "empty";
    } catch (e) {
      console.warn("[Sommelier] Catalog fetch failed:", e);
      state.catalogStatus = "empty";
    }
    updateSubtitle();
  }

  function updateSubtitle() {
    const el = document.querySelector(".tlc-som-subtitle");
    if (!el) return;
    if (state.catalogStatus === "loading") el.textContent = "Connecting to the cellar…";
    else if (state.catalogStatus === "live") el.textContent = `${state.catalog.length} bottles in stock`;
    else el.textContent = "At your service";
  }

  // ---------- rendering ----------
  function renderProductCard(product) {
    const fallbackSvg = `<svg viewBox="0 0 32 32" fill="none" stroke="#C9A063" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="width:28px;height:28px;"><path d="M10 5 C 10 5, 8.5 11, 9.5 15 C 10.5 19, 13 21, 16 21 C 19 21, 21.5 19, 22.5 15 C 23.5 11, 22 5, 22 5 Z"/><line x1="16" y1="21" x2="16" y2="25"/><ellipse cx="16" cy="26" rx="4.5" ry="1.2"/></svg>`;
    const imgHtml = product.image
      ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
      : `<div class="tlc-som-product-img-fallback">${fallbackSvg}</div>`;
    return `
      <a class="tlc-som-product" href="/products/${escapeHtml(product.handle)}" target="_blank" rel="noopener">
        <div class="tlc-som-product-img">${imgHtml}</div>
        <div class="tlc-som-product-info">
          <div class="tlc-som-product-title">${escapeHtml(product.title)}</div>
          <div class="tlc-som-product-type">${escapeHtml(product.type || "Spirit")}</div>
        </div>
        <div class="tlc-som-product-price">${formatPrice(product.price)}</div>
      </a>
    `;
  }

  function renderMessage(msg, isFirstAssistant) {
    if (msg.role === "user") {
      return `<div class="tlc-som-msg-user">${escapeHtml(msg.content)}</div>`;
    }
    const labelHtml = isFirstAssistant
      ? `<div class="tlc-som-msg-asst-label">The Sommelier</div>`
      : "";
    const productsHtml = (msg.recommendations || [])
      .map(findProduct)
      .filter(Boolean)
      .map(renderProductCard)
      .join("");
    return `
      <div class="tlc-som-msg-asst">
        ${labelHtml}
        <div class="tlc-som-msg-asst-text">${escapeHtml(msg.content)}</div>
        ${productsHtml}
      </div>
    `;
  }

  function renderBody() {
    const body = document.querySelector(".tlc-som-body");
    if (!body) return;

    if (state.messages.length === 0) {
      body.innerHTML = `
        <div class="tlc-som-welcome">
          <div class="tlc-som-welcome-title">Welcome.</div>
          <div class="tlc-som-welcome-body">
            I'm here to help you find the right bottle —<br>
            for tonight's meal, a quiet pour, or someone special.
          </div>
        </div>
      `;
      return;
    }

    let assistantSeen = false;
    const html = state.messages
      .map((m) => {
        const first = !assistantSeen && m.role === "assistant";
        if (m.role === "assistant") assistantSeen = true;
        return renderMessage(m, first);
      })
      .join("");

    const loadingHtml = state.loading
      ? `<div class="tlc-som-loading"><div class="tlc-som-spinner"></div><span>consulting the cellar…</span></div>`
      : "";

    body.innerHTML = html + loadingHtml;
    body.scrollTop = body.scrollHeight;
  }

  function renderStarters() {
    const starters = document.querySelector(".tlc-som-starters");
    if (!starters) return;
    starters.style.display = state.messages.length === 0 && !state.loading ? "grid" : "none";
  }

  function renderSendButton() {
    const sendBtn = document.querySelector(".tlc-som-send");
    const input = document.querySelector(".tlc-som-input");
    if (!sendBtn || !input) return;
    const active = input.value.trim().length > 0 && !state.loading;
    sendBtn.classList.toggle("tlc-som-send-active", active);
    sendBtn.disabled = !active;
  }

  // ---------- send message ----------
  async function sendMessage(text) {
    const trimmed = text.trim();
    if (!trimmed || state.loading) return;

    state.messages.push({ role: "user", content: trimmed });
    state.loading = true;
    document.querySelector(".tlc-som-input").value = "";
    renderBody();
    renderStarters();
    renderSendButton();

    try {
      // Build compact catalog string from in-memory products
      const catalogString = state.catalog
        .map((p) => `${p.handle} | ${p.title} | ${p.type || "Spirit"} | S$${p.price}`)
        .join("\n");

      const res = await fetch(WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          messages: state.messages.map((m) => ({ role: m.role, content: m.content })),
          catalog: catalogString,
        }),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || `HTTP ${res.status}`);
      }

      const data = await res.json();
      const responseText = data.text || "";
      const { text: cleanText, handles } = extractRecs(responseText);

      state.messages.push({
        role: "assistant",
        content: cleanText || "Apologies — I had trouble responding. Try again?",
        recommendations: handles,
      });
    } catch (e) {
      console.error("[Sommelier] Send error:", e);
      state.messages.push({
        role: "assistant",
        content: e.message?.includes("limit")
          ? e.message
          : "The cellar is briefly inaccessible. Please try again in a moment.",
        recommendations: [],
      });
    } finally {
      state.loading = false;
      renderBody();
      renderStarters();
      renderSendButton();
    }
  }

  // ---------- panel mount ----------
  const STARTERS = [
    { icon: "🍷", label: "Recommend a bottle", prompt: "I'd like a bottle recommendation. Help me narrow it down." },
    { icon: "🍽️", label: "Pair with food", prompt: "I need a pairing for dinner tonight." },
    { icon: "🎁", label: "Find a gift", prompt: "I'm looking for a gift bottle." },
    { icon: "✨", label: "Surprise me", prompt: "Tell me something interesting from your collection — surprise me." },
  ];

  function buildPanel() {
    const panel = document.createElement("div");
    panel.className = "tlc-som-panel";
    panel.innerHTML = `
      <div class="tlc-som-header">
        <div>
          <div class="tlc-som-title">The Sommelier</div>
          <div class="tlc-som-subtitle">Connecting to the cellar…</div>
        </div>
        <button class="tlc-som-close" aria-label="Close">×</button>
      </div>
      <div class="tlc-som-body"></div>
      <div class="tlc-som-starters">
        ${STARTERS.map((s, i) => `
          <button class="tlc-som-starter" data-prompt="${escapeHtml(s.prompt)}">
            <span class="tlc-som-starter-icon">${s.icon}</span>
            <span>${escapeHtml(s.label)}</span>
          </button>
        `).join("")}
      </div>
      <div class="tlc-som-input-area">
        <div class="tlc-som-input-row">
          <textarea class="tlc-som-input" placeholder="Ask the sommelier…" rows="1"></textarea>
          <button class="tlc-som-send" aria-label="Send" disabled>➤</button>
        </div>
        <div class="tlc-som-footer-note">Powered by Claude · The Liquid Collection</div>
      </div>
    `;
    return panel;
  }

  function openPanel() {
    if (state.isOpen) return;
    state.isOpen = true;

    const wrap = document.querySelector(".tlc-som-bubble-wrap");
    if (wrap) wrap.style.display = "none";

    const panel = buildPanel();
    document.body.appendChild(panel);

    panel.querySelector(".tlc-som-close").addEventListener("click", closePanel);

    panel.querySelectorAll(".tlc-som-starter").forEach((btn) => {
      btn.addEventListener("click", () => sendMessage(btn.dataset.prompt));
    });

    const input = panel.querySelector(".tlc-som-input");
    const send = panel.querySelector(".tlc-som-send");

    input.addEventListener("input", () => {
      input.style.height = "auto";
      input.style.height = Math.min(input.scrollHeight, 120) + "px";
      renderSendButton();
    });
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        sendMessage(input.value);
      }
    });
    send.addEventListener("click", () => sendMessage(input.value));

    setTimeout(() => input.focus(), 100);
    renderBody();
    updateSubtitle();
  }

  function closePanel() {
    state.isOpen = false;
    const panel = document.querySelector(".tlc-som-panel");
    if (panel) panel.remove();
    const wrap = document.querySelector(".tlc-som-bubble-wrap");
    if (wrap) wrap.style.display = "flex";
  }

  function buildBubble() {
    const wrap = document.createElement("div");
    wrap.className = "tlc-som-bubble-wrap";

    // Floating "ask me anything" label
    const label = document.createElement("div");
    label.className = "tlc-som-label";
    label.innerHTML = `
      <span>ask me anything</span>
      <span class="tlc-som-label-close" aria-label="Dismiss">×</span>
    `;
    // Click on label body opens the panel; click on × dismisses just the label
    label.addEventListener("click", (e) => {
      if (e.target.classList.contains("tlc-som-label-close")) {
        e.stopPropagation();
        label.style.display = "none";
        try { sessionStorage.setItem("tlc-som-label-dismissed", "1"); } catch (_) {}
      } else {
        openPanel();
      }
    });
    // Don't show label if already dismissed this session
    try {
      if (sessionStorage.getItem("tlc-som-label-dismissed") === "1") {
        label.style.display = "none";
      }
    } catch (_) {}

    // Bubble with Glencairn nosing glass SVG
    const bubble = document.createElement("button");
    bubble.className = "tlc-som-bubble";
    bubble.setAttribute("aria-label", "Open Sommelier");
    bubble.innerHTML = `
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
        <!-- Glencairn nosing glass: tulip bowl on short stem and base -->
        <path d="M10 5 C 10 5, 8.5 11, 9.5 15 C 10.5 19, 13 21, 16 21 C 19 21, 21.5 19, 22.5 15 C 23.5 11, 22 5, 22 5 Z"/>
        <!-- Whisky line -->
        <path d="M10.5 14 C 13 15.5, 19 15.5, 21.5 14" stroke-width="1.4"/>
        <!-- Stem -->
        <line x1="16" y1="21" x2="16" y2="25"/>
        <!-- Base -->
        <ellipse cx="16" cy="26" rx="4.5" ry="1.2"/>
      </svg>
      <span class="tlc-som-bubble-pulse"></span>
    `;
    bubble.addEventListener("click", openPanel);

    wrap.appendChild(label);
    wrap.appendChild(bubble);
    return wrap;
  }

  // ---------- init ----------
  function init() {
    if (WORKER_URL.includes("YOUR-SUBDOMAIN")) {
      console.warn("[Sommelier] WORKER_URL is not configured. Edit assets/sommelier.js.");
      return;
    }
    injectStyles();
    document.body.appendChild(buildBubble());
    fetchCatalog();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
